import { useState } from "react";
import { useEmailLinkLogin } from "../../hooks/auth/useEmailLinkLogin";
import { signInWithGoogle } from "../../hooks/auth/useGoogleSignIn";

import styles from "./Login.module.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const { sendSignInLink, error, isPending, linkSent } = useEmailLinkLogin();

  const handleSubmit = (event) => {
    event.preventDefault();
    sendSignInLink(email);
  };

  const handleEmailChange = (event) => {
    const emailValue = event.target.value;
    // Firebase automatically rejects email addresses that are too long
    setEmail(emailValue);
    setIsEmailValid(
      emailValue.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) !== null
    );
  };

  return (
    <form onSubmit={handleSubmit} className={styles["login-form"]}>
      <h2>Đăng Nhập</h2>

      <ul>
        <li>
          Cựu học viên: nhập địa chỉ email mà bạn đã dùng khi ghi danh với Dẫu
          Phải Giải Phẫu (gesture, anatomy, sculpting, rigging, coding) trong
          quá khứ
        </li>
        <li>
          Khách lạ: những ai chưa từng học một khoá nào bao giờ với "Dẫu Phải
          Giải Phẫu" vẫn có thể đăng nhập để xem các tài liệu miễn phí 😌
        </li>
      </ul>

      {/* <label>
        <span>Email:</span>
        <input
          type="email"
          id="email"
          name="email"
          value={email}
          onChange={handleEmailChange}
          required
          placeholder="Nhập email"
        />
      </label>

      <button
        type="submit"
        className="btn"
        disabled={isPending || !isEmailValid}
      >
        {isPending ? "Đang gửi..." : "Gửi Login link"}
      </button> */}

      <div style={{ margin: "16px 0", textAlign: "center" }}>
        <button
          type="button"
          className="btn"
          style={{
            background: "#fff",
            color: "#444",
            border: "1px solid #ccc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            width: "100%",
            maxWidth: 320,
            margin: "0 auto",
          }}
          onClick={async () => {
            const { error } = await signInWithGoogle();
            if (error) {
              alert("Google sign-in failed: " + error.message);
            }
          }}
        >
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google"
            style={{ width: 24, height: 24 }}
          />
          <span>Sign in with Google</span>
        </button>
      </div>

      {error && <p>{error}</p>}

      {linkSent && (
        <div className={styles.sent}>
          <p>Đã gửi Login link!</p>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/dpgp-techart.appspot.com/o/login-instructions%2FGmail-threads-collapsed.jpg?alt=media&token=ca91abb2-1326-4d56-a64b-9b69d7342878"
            alt="Gmail-threads-collapsed"
          />
          <p>
            Vui lòng check email và bấm vào link bên trong email vừa nhận được
            để login
          </p>
        </div>
      )}
    </form>
  );
}
